import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Row, Col, Button, Input } from "reactstrap";
// import leftarrow from 'assets/icon/leftarrow.svg';
// import rightarrow from 'assets/icon/rightarrow.svg';
// import leftbackward from 'assets/icon/leftbackward.svg';
// import rightforward from 'assets/icon/rightforward.svg';
import leftarrow from "assets/icon/QualificationLeftArrow.svg";
import rightarrow from "assets/icon/QualificationRightArrow.svg";
import leftbackward from "assets/icon/QualificationDoubleLeftArrow.svg";
import rightforward from "assets/icon/QualificationDoubleArrowRight.svg";
import save from "assets/icon/save.svg";


import useAxios from "hooks/useAxios";
import Confirm from "components/Confirm";
import { toast } from "react-toastify";
import Loader from "components/Loader";

let selcoloumdata = [];
let autoselectlist = [];
let ids = [];
let roleids = [];
let isRole = ["GWPHA", "GWPHU"];
let disableFields = ['Total Ordered Price', 'Total Invoiced Price'];
const DragDrop = (props) => {
  const API = useAxios();
  const { cancalcolselect, refetch, reloadautocolum, modulename } = props;

  useEffect(() => {
    handlAutocoloms();
    roleids = [];
  }, []);
  useEffect(() => {
    handleselectcoloums();
  }, []);
  const [activeids, setActiveids] = useState([]);
  const [activeId, setActiveId] = useState(-1);
  const [box, setBox] = useState([]);

  const [box1, setBox1] = useState([]);
  const [isConfirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const pharmaforce = sessionStorage.getItem("pharmaforce");
  const { token_type, access_token, profile } =
  JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
   const { roles } = profile || {};
   console.log(roles,"roles")
   var isDisable = isRole.includes(roles);
   console.log(isDisable,"isDisable")

  const handleselectcoloums = async () => {
    setBox1([]);
    selcoloumdata = [];
    let datacol = {};
    try {
      datacol = await API.get(`GWConfig/coveredEntity/coloumslist/${modulename}`, {
        hasDefaultURL: true,
      });

      if (datacol.data) {
        if (isDisable && (modulename == "PurchaseOrders" || modulename == "Non340BPurchaseOrders")) {
          for (var m in datacol.data) {
            if (!disableFields.includes(datacol.data[m].displayName)) {
              selcoloumdata.push({ "id": datacol.data[m].gridColumnsID, "title": datacol.data[m].displayName, "index": datacol.data[m].displayOrder })
              setBox1(selcoloumdata);
            }
          }
          setActiveids([]);
        }
        else {
          for (var x in datacol.data) {
            selcoloumdata.push({ "id": datacol.data[x].gridColumnsID, "title": datacol.data[x].displayName, "index": datacol.data[x].displayOrder })
            setBox1(selcoloumdata);
          }
          setActiveids([]);
        }
      }
    } catch (err) {
      setActiveids([]);
    }
  };

  const handleOnDragEnd = (result) => {
    if (result.destination) {
      const newBox = Array.from(box);
      const [draggedItem] = newBox.splice(result.source.index, 1);
      newBox.splice(result.destination.index, 0, draggedItem);
      var iCount = 0;
      for (var x in newBox) {
        newBox[x].index = iCount;
        iCount += 1;
      }
      setBox(newBox);
      (box);
    }
  };

  // const handleLeftClick = (id) => {
  //     setActiveId(id);
  // }

  // const handleRightClick = (id) => {
  //     setActiveId(id);
  // }

  const handleRight = () => {

    ids = [];
    if (activeids.length > 0) {
      let mainData1 = box1.filter((list) => activeids.includes(list.id));
      if (mainData1.length > 0) {
        var boxLength = box.length;
        for (var x in mainData1) {
          // ids.push({ "id": mainData1[x].id, "title": mainData1[x].title, "index": box.length + 1 });
          boxLength += 1;
          ids.push({
            id: mainData1[x].id,
            title: mainData1[x].title,
            index: boxLength,
          });
        }
        var item1 = [...box, ...ids];
        setBox(item1);
        let mainDataAfterMove1 = box1.filter(
          (list) => !activeids.includes(list.id)
        );
        setBox1(mainDataAfterMove1);
        setActiveids([]);
        roleids = [];
      }
    }
    // else {
    //     let mainData = box1.filter((list) => list.id === activeId);
    //     if (mainData.length > 0) {
    //         var item = {};
    //         item.id = mainData[0].id;
    //         item.title = mainData[0].title;
    //         item.index = box.length + 1;
    //         var item1 = [...box, item];
    //         setBox(item1);
    //         let mainDataAfterMove = box1.filter((list) => list.id !== activeId);
    //         setBox1(mainDataAfterMove);
    //         setActiveId(-1);

    //     }
    // }
  };

  const handlAutocoloms = async () => {
    autoselectlist = [];
    setLoading(true);

    try {
      const { data } = await API.get(
        `GWConfig/coveredEntity/autoselectcoloumslist/${modulename}`,
        {
          hasDefaultURL: true,
        }
      );
      if (data.length > 0) {
        for (var x in data) {
          autoselectlist.push({
            id: data[x].gridColumnsID,
            title: data[x].displayName,
            index: data[x].displayOrder,
          });
          setBox(autoselectlist);
        }
        setActiveids([]);
        setLoading(false);
      } else {
        setBox([]);
        setActiveids([]);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const handlesave = async () => {
    handleSaveConfirmation();
    let payload = box;
    setLoading(true);
    try {
        const { data } = await API.post(`GWConfig/coveredentity/selectcoloumslist`, payload, {
            hasDefaultURL: true,
        });
      if (data) {
        toast.success("Columns Saved Successfully");
        cancalcolselect();
        reloadautocolum();
        refetch();
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const handleLeft = () => {

    ids = [];
    if (activeids.length > 0) {
      let mainData = box.filter((list) => activeids.includes(list.id));
      if (mainData.length > 0) {
        var boxLength = box.length;
        for (var x in mainData) {
          // ids.push({ "id": mainData[x].id, "title": mainData[x].title, "index": box.length + 1 });
          boxLength += 1;
          ids.push({
            id: mainData[x].id,
            title: mainData[x].title,
            index: boxLength,
          });
        }
        var item1 = [...box1, ...ids];
        setBox1(item1);
        let mainDataAfterMove = box.filter(
          (list) => !activeids.includes(list.id)
        );
        setBox(mainDataAfterMove);
        setActiveids([]);
        roleids = [];
      }
    } else {
      let mainData = box.filter((list) => list.id === activeId);
      if (mainData.length > 0) {
        var item = {};
        item.id = mainData[0].id;
        item.title = mainData[0].title;
        item.index = box1.length + 1;
        var item1 = [...box1, item];
        setBox1(item1);

        let mainDataAfterMove = box.filter((list) => list.id !== activeId);
        setBox(mainDataAfterMove);
        setActiveids([]);
        roleids = [];
      }
    }
  };

  const handleAllRight = () => {
    if (box1.length > 0) {
      if (box.length > 0) {
        var boxLength = box.length;
        var ids = [];
        for (var x in box1) {
            boxLength += 1;
          ids.push({
            id: box1[x].id,
            title: box1[x].title,
            index: boxLength,
          });
        }
        var item1 = [...box, ...ids];
        setBox(item1);
        setBox1([]);
      } else {
        var item1 = [...box, ...box1];
        setBox(item1);
        setBox1([]);
        setActiveids([]) ;
        roleids = [];
      }
    }
  };

  const handleAllLeft = () => {
    if (box.length > 0) {
      var item1 = [...box1, ...box];
      setBox1(item1);
      setBox([]);
          setActiveids([]);
          roleids = [];
    }
  };

  const handleSaveConfirmation = () => {
    setConfirm(!isConfirm);
  };
  const reset = () => {
    handlAutocoloms();
    handleselectcoloums();
  };
  const onChange = (e, id) => {
    var check = e.target.checked;

    if (check == true) {
      setActiveids([]);
      roleids.push(id);
      setActiveids(roleids);
    } else {
      if (roleids.length > 0) {
        let index = roleids.indexOf(id);
        roleids.splice(index, 1);
        setActiveids(roleids);
      }
    }
    // if (!activeids.includes(id)) {
    //     setActiveids([]);
    //     roleids.push(id);
    //     setActiveids(roleids)
    // }
    // else {
    //     if(roleids.length>0)
    //     {
    //         roleids.pop(id);
    //        setActiveids(roleids);
    //     }

    // }
  };
  const renderCheckbox = (id, title, index) => {
    //const filter = activeids.filter((item) => item === id);
    return (
      <Input
        onChange={(e) => onChange(e, id)}
        type="checkbox"
        className="me-2 mt-0"
      //  value={filter.length > 0}
      //  checked={filter.length > 0}
      />
    );
  };
  return (
    <div className="picker_info" style={{ margin: "0 auto" }}>
      {loading && <Loader />}
      <Row>
        <Col md={5}>
          <div>
            <h3>Available Columns</h3>
            <ul>
              {box1.map(({ id, title }, index) => (
                <li key={id}>
                  <div className="box d-flex" style={{width:'auto'}}>
                    <span className="d-flex align-items-start" style={{ paddingTop: "5px" }}>
                      {renderCheckbox(id, title, index)}
                    </span>
                    {title}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </Col>
        <Col md={2}>
          <div className="d-flex justify-content-center pt-5 qualification">
            <div className="icons_list mt-2">
              <div className="pb-3">
                <img src={rightarrow} alt="" width={32} onClick={handleRight} />
              </div>
              <div>
                 <img src={leftarrow} alt="" width={32} onClick={handleLeft} />
              </div>
              <div className="pt-4 pb-3">
                <img
                  src={rightforward}
                  alt=""
                  width={32}
                  onClick={handleAllRight}
                />
              </div>
              <div>
                <img
                  src={leftbackward}
                  alt=""
                  width={32}
                  onClick={handleAllLeft}
                />
              </div>
            </div>
          </div>
        </Col>
        <Col md={5}>
          <div>
            <h3>Selected Columns</h3>
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId="boxes">
                {(provided) => (
                  <ul ref={provided.innerRef} {...provided.droppableProps}>
                    {box.map(({ id, title }, index) => (
                      <Draggable
                        key={id}
                        draggableId={id.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <li
                            key={id}
                            ref={provided.innerRef}
                            {...provided.dragHandleProps}
                            {...provided.draggableProps}
                          >
                            <div className="box d-flex" style={{width:'auto'}}>
                              <span className="d-flex align-items-start" style={{ paddingTop: "5px" }}>
                                {renderCheckbox(id, title, index)}
                              </span>
                              {title}
                            </div>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div style={{ float: "right" }}>
          <Button className="search" onClick={handleSaveConfirmation}                         
          color="primary">
             <span className="right_5">
                          <img src={save} alt="" />
                        </span>{" "}
                            save
                        </Button>
                        {/* <Button onClick={cancalcolselect}>
                            Cancel
                        </Button>
                        <Button onClick={reset}>
                            Reset
                        </Button> */}
          </div>
        </Col>
      </Row>
      <Confirm
        isOpen={isConfirm}
        //loading={loading}
        message="Are you sure you want to save?"
        onToggle={handleSaveConfirmation}
        onCancel={handleSaveConfirmation}
        onContinue={handlesave}
      />
    </div>
  );
};
export default DragDrop;
